import React, { Component } from 'react';
import { connect } from 'react-redux';
import { deleteVehicleColumnOption, updateVehicleColumnOption } from '../../../actions/apiDepartmentUpdates';

class DisplayOptions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value,
			optionNames: DisplayOptions.namesFromOptions(props.options),
		};
		this.deleteOption = this.deleteOption.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeName = this.onChangeName.bind(this);
		this.onBlurName = this.onBlurName.bind(this);
		this.onKeyDownName = this.onKeyDownName.bind(this);
	}

	static namesFromOptions(options) {
		const optionNames = {};
		(options || []).forEach((option) => {
			optionNames[option.id] = option.name;
		});
		return optionNames;
	}

	componentDidUpdate(prevProps) {
		const prev = (prevProps.options || []).map(o => `${o.id}:${o.name}`).join('|');
		const next = (this.props.options || []).map(o => `${o.id}:${o.name}`).join('|');
		if (prev !== next) {
			this.setState({ optionNames: DisplayOptions.namesFromOptions(this.props.options) });
		}
	}

	onChange(e) {
		this.setState({ value: e.value });
	}

	onChangeName(e) {
		const id = e.target.dataset.dbid;
		this.setState({
			optionNames: { ...this.state.optionNames, [id]: e.target.value },
		});
	}

	onBlurName(e) {
		const id = e.target.dataset.dbid;
		const name = (e.target.value || '').trim();
		const original = (this.props.options || []).find(o => String(o.id) === String(id));
		if (!original) {
			return;
		}
		if (!name || name === original.name) {
			if (this.state.optionNames[id] !== original.name) {
				this.setState({
					optionNames: { ...this.state.optionNames, [id]: original.name },
				});
			}
			return;
		}
		this.props.updateVehicleColumnOption(id, this.props.column_id, { id, name }, 'editOptionError');
	}

	onKeyDownName(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			e.target.blur();
		}
	}

	deleteOption(e) {
		const id = e.currentTarget.dataset.dbid;
		const errorType = 'delete option';
		const { column_id } = this.props;
		this.props.deleteVehicleColumnOption(id, column_id, errorType);
	}

	render() {
		const options = this.props.options || [];
		let cols = [];

		if (typeof options !== 'undefined') {
			cols = options.map(option => <li className="list-group-item" key={`opt_${option.id}`}>
				<div className="d-flex align-items-center justify-content-between">
					<input
						className="form-control me-2"
						type="text"
						data-dbid={option.id}
						value={this.state.optionNames[option.id] ?? option.name}
						onChange={this.onChangeName}
						onBlur={this.onBlurName}
						onKeyDown={this.onKeyDownName}
						aria-label={`Option name ${option.name}`}
					/>
					<button type="button" className="btn btn-sm btn-danger" data-dbid={option.id} onClick={this.deleteOption}>x</button>
				</div>
                                                    </li>);
		}

		return (
			<div className="p-2">
				<div className="showOptions">
					<ul className="list-group">
						<li className="list-group-item blockquote text-center">Add/Edit/Delete Options</li>
						{cols}
					</ul>
				</div>
			</div>

		);
	}
}

const mappedActions = {
	deleteVehicleColumnOption,
	updateVehicleColumnOption,
};

function mapStateToProps(state) {
	return {};
}
export default connect(mapStateToProps, mappedActions)(DisplayOptions);
